import { Button } from "components/Button";
import { MaxWidth } from "components/MaxWidth";
import styles from "./CourseCTA.module.css";

export const CourseCTA = ({ buttons, title }) => (
  <MaxWidth>
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.buttonContainer}>
        {buttons.map((button) => (
          <Button key={button.label} {...button}>
            {button.label}
          </Button>
        ))}
      </div>
    </div>
  </MaxWidth>
);
